import { getLang } from "$lib/translations/translations";

export function getMaruFont(url: URL): string | null
{
    let maru_font = '';
    const langResult = getLang(url);
    if (langResult.isFailure) return null;
    const lang = langResult.value;
    switch (lang) {
        case 'ja':
            maru_font = 'font-maru-jp';
            break;
        case 'zh-cn':
            maru_font = 'font-maru-zh';
            break;
        case 'zh-tw':
            maru_font = 'font-maru-zh';
            break;
    }
    return maru_font;
}
